{
  "conflict": {
    "title": "Conflit d'horaire détecté",
    "defaultMessage": "Un autre utilisateur a modifié la position de cet appareil. Vos modifications pourraient remplacer les siennes.",
    "attemptProgress": "Tentative {{current}} sur {{max}}",
    "retryExplanation": "• Réessayer tentera d'enregistrer vos modifications à nouveau, ce qui pourrait écraser les modifications de l'autre utilisateur.",
    "cancelExplanation": "• Annuler supprimera vos modifications et rechargera l'état actuel.",
    "cancelButton": "Annuler",
    "retryButton": "Réessayer"
  },
  "confirmation": {
    "defaultCancel": "Annuler",
    "defaultOk": "OK",
    "typeToConfirm": "Tapez « supprimer » pour confirmer la suppression.",
    "deletePlaceholder": "supprimer"
  },
  "progress": {
    "defaultItemName": "item",
    "processing": "Traitement de {{current}} sur {{total}} {{itemName}}",
    "processingPlural": "Traitement de {{current}} sur {{total}} {{itemName}}",
    "currentLabel": "Actuel : {{currentItem}}"
  },
  "error": {
    "defaultTitle": "Oups ! Une erreur s'est produite",
    "defaultDescription": "Une erreur inattendue s'est produite.",
    "teamNotified": "L'équipe AirPlx a été informée et examine le problème.",
    "errorDetailsLabel": "Détails erreur (dev) :",
    "componentStackLabel": "Pile de composants",
    "refreshButton": "Actualiser la page",
    "returnHome": "Retour accueil"
  },
  "notes": {
    "title": "Notes de l'aéronef",
    "label": "Notes",
    "placeholder": "Heure de départ : 24/05/2025 12:00",
    "lastUpdate": "Dernière mise à jour : {{time}} ({{date}}) par {{user}}",
    "cancelButton": "Annuler",
    "saveButton": "Enregistrer"
  }
}
